import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { FooterComponent } from './footer.component';
import { SharedModule }    from '../shared/shared.module';

@NgModule({
  declarations: [
    FooterComponent
  ],
  entryComponents: [
    FooterComponent
  ],
  imports: [
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class FooterModule {}
